<template>
<div class="chapter">
<div class="inner_page">
<p class="poem1">For now, this fearful night,</p>
<p class="poem3">There is no stir, or walking in the streets;</p>
<p class="poem3">And the complexion of the element</p>
<p class="poem3">In favour’s like the work we have in hand,</p>
<p class="poem3">Most bloody, fiery, and most terrible.</p>
<p class="pright">—Shakespeare</p>
<p class="pright"><i>Julius Caesar</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f006.vue?5058976c